import { render, staticRenderFns } from "./uploadRes.vue?vue&type=template&id=17f49bca&scoped=true"
import script from "./uploadRes.vue?vue&type=script&lang=js"
export * from "./uploadRes.vue?vue&type=script&lang=js"
import style0 from "./uploadRes.vue?vue&type=style&index=0&id=17f49bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f49bca",
  null
  
)

export default component.exports